import React from "react";
import { Form } from "react-bootstrap";
import { DropdownMenuProps } from "./Dropdown.interface";
import { Menu } from "./Dropdown.styled";

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  columns,
  visibleColumns,
  toggleColumnVisibility,
}) => {
  return (
    <Menu role="menu">
      {columns.map((column) => (
        <Form.Check
          key={column}
          type="checkbox"
          label={column}
          id={`checkbox-${column}`}
          checked={visibleColumns.includes(column)}
          onChange={() => toggleColumnVisibility(column)}
        />
      ))}
    </Menu>
  );
};

export default DropdownMenu;
